const { default: BrowseAccountRoute } = require("./BrowseAccount/BrowseAccountRoute");
const { default: DetailAccountRoute } = require("./DetailAccount/DetailAccountRoute");

export default { BrowseAccountRoute, DetailAccountRoute }